import React, { ReactNode } from "react";

import styles from "./fundForm.module.scss";

interface IFormSection {
  title: string;
  subtitle?: string;
  meta?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  /** Omits the rule under the header, for sections whose body supplies its own. */
  plainHeader?: boolean;
  /** Renders the body without the standard padding, for tabs and tables. */
  bare?: boolean;
  id?: string;
  children: ReactNode;
}

/**
 * One titled card on the form.
 *
 * The whole point of the redesign: a fund is four decisions, not forty fields
 * in a column. Each section states what it is for, so the page can be scanned
 * before it is filled in.
 */
export default function FormSection({
  title,
  subtitle,
  meta,
  icon,
  action,
  plainHeader = false,
  bare = false,
  id,
  children,
}: IFormSection) {
  return (
    <section className={styles.section} id={id}>
      <header
        className={`${styles.sectionHead} ${
          plainHeader ? styles.sectionHeadPlain : ""
        }`}
      >
        <div className={styles.sectionTitleRow}>
          {icon ? <div className={styles.sectionIcon}>{icon}</div> : null}
          <div>
            <div className={styles.sectionTitle}>{title}</div>
            {subtitle ? (
              <div className={styles.sectionSubtitle}>{subtitle}</div>
            ) : null}
          </div>
        </div>

        {action ?? (meta ? <span className={styles.sectionMeta}>{meta}</span> : null)}
      </header>

      {bare ? children : <div className={styles.sectionBody}>{children}</div>}
    </section>
  );
}
